import { Box, CircularProgress, Typography, useMediaQuery, useTheme } from "@mui/material"
import { IconCheck, IconCircle, IconCirclePlus, IconEqual, IconLoader } from "@tabler/icons-react"
import { usePartner } from "~/contexts"
import { CalculateCommissionMutation } from "~/graphql/types"

export enum ComissionType {
  initial = 'initial',
  recurring = 'recurring',
}

type ComissionSelected = {
  text: string
}

type ComissionCardProps = {
  typeComission: ComissionType
  hasComissionSelected?: boolean
  additionalCommissionPercentage: number
  baseCommissionPercentage: number
  commissionAmountPercentage: number
}

export const ComissionCard: React.FC<ComissionCardProps> = ({ typeComission, hasComissionSelected, additionalCommissionPercentage, baseCommissionPercentage, commissionAmountPercentage }) => {
  const theme = useTheme()
  const isLowerSm = useMediaQuery(theme.breakpoints.down('sm'))

  const comissionsTypes: { [x in ComissionType]: ComissionSelected } = {
    initial: {
      text: 'Comissão inicial',
    },
    recurring: {
      text: 'Comissão recorrente',
    }
  }

  const selectedComission = comissionsTypes[typeComission]

  return (
    <Box translate='no' sx={{ background: '#fafafa', border: `1px solid ${theme.palette.grey[300]}`, padding: '1.4rem', borderRadius: '.8rem' }}>
    <Typography sx={{ paddingBottom: '1rem' }} variant='h3' fontWeight={500} color={theme.palette.grey[800]}>{selectedComission.text}</Typography>

      <Box sx={{ display: 'flex', gap: isLowerSm ? '1rem' : '2rem', alignItems: isLowerSm ? 'flex-start' : 'center', flexFlow: isLowerSm ? 'column' : 'row' }}>
        <Box sx={{ display: 'flex', flexFlow: 'column', gap: '.2rem' }}>
          <Typography variant='body2' color={theme.palette.grey[600]}>Comissão base</Typography>
          <Typography variant='h3' fontWeight={500} color={theme.palette.grey[800]}>{baseCommissionPercentage}%</Typography>
        </Box>
        <IconCirclePlus color={theme.palette.secondary.main} size={18} />
        <Box sx={{ display: 'flex', flexFlow: 'column', gap: '.2rem' }}>
          <Typography variant='body2' color={theme.palette.grey[600]}>Comissão adicional</Typography>
          <Typography variant='h3' fontWeight={500} color={hasComissionSelected ? theme.palette.grey[800] : theme.palette.grey[300]}>{additionalCommissionPercentage}%</Typography>
        </Box>
        <Box sx={{ position: 'relative' }}>
          <IconCircle color={theme.palette.secondary.main} size={18} />
          <IconEqual color={theme.palette.secondary.main} size={14} style={{ position: 'absolute', top: '2px', left: '2px' }} />
        </Box>
        <Box sx={{ display: 'flex', flexFlow: 'column', gap: '.2rem' }}>
          <Typography variant='body2' color={theme.palette.grey[600]}>Comissão final</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '.6rem' }}>
            <IconCheck color={hasComissionSelected ? theme.palette.success.main : theme.palette.grey[300]} />
            <Typography variant='h3' fontWeight={500} color={hasComissionSelected ? theme.palette.grey[800] : theme.palette.grey[300]}>{commissionAmountPercentage}%</Typography>
          </Box>
        </Box>
      </Box>
  </Box>
  )
}

type ComissionCardLoadingProps = {
  text: string
}

export const ComissionCardLoading: React.FC<ComissionCardLoadingProps> = ({ text }) => {
  const theme = useTheme()
  return (
    <Box translate='no' sx={{ background: '#fafafa', border: `1px solid ${theme.palette.grey[300]}`, padding: '1.4rem', borderRadius: '.8rem', filter: 'opacity(0.5)' }}>
    <Typography sx={{ paddingBottom: '1rem' }} variant='h3' fontWeight={500} color={theme.palette.grey[800]}>{text}</Typography>
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <CircularProgress size={32} color='inherit' />
    </Box>
  </Box>
  )
}